import { render, staticRenderFns } from "./PedimentosLoadDocument.vue?vue&type=template&id=7cb1dd0e"
import script from "./PedimentosLoadDocument.vue?vue&type=script&lang=js"
export * from "./PedimentosLoadDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports